<template>
  <div class="home">
    <div class="left">
      <h1>Authentic test results, <span class="verified">verified.</span></h1>
      <p>Giving you the power to protect in a post-quarantine world.</p>
      <div class="app-links">
        <!-- TODO: Add href to link when it will be ready -->
        <a href="https://apps.apple.com/us/app/cerdio-authentication/id1532693068" target="_blank" rel="noopener">
          <img alt="appstore-badge" src="../assets/appstore-badge.svg">
        </a>
        <!-- TODO: Add href to link when it will be ready -->
        <a href="https://play.google.com/store/apps/details?id=com.cerdio.auth" target="_blank" rel="noopener">
          <img alt="google-play-badge" src="../assets/google-play-badge.svg">
        </a>
      </div>
    </div>
    <div class="right">
      <img src="../assets/iphone.png"
           srcset="../assets/iphone@2x.png 2x,
               ../assets/iphone@3x.png 3x"
           class="iphone">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped lang="scss">
.home {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .left {
    padding-right: 0;
    color: #354051;

    h1 {
      font-size: 4.4em;
      font-weight: 700;
      line-height: 1.29;
      text-align: left;

      .verified {
        color: #ffffff;
        background-color: #47c97f;
      }
    }

    p {
      font-size: 1.6rem;
      line-height: 1.94;
      text-align: left;
      margin: 2.4rem 0 3.2rem 0;
    }

    .app-links {
      text-align: left;

      a:first-child {
        margin-right: 0.5rem;
      }

      a:last-child {
        margin-left: 0.5rem;
      }
    }

    @media (min-width: 768px) {
      padding-right: 4rem;
      width: 50%;

      h1 {
        font-size: 4.8rem;
        line-height: 1.29;
      }
    }

    @media (min-width: 1440px) {
      width: 60%;

      h1 {
        font-size: 7.2rem;
        line-height: 1.11;
      }

      .app-links {
        a:first-child {
          margin-right: 2rem;
        }

        a:last-child {
          margin-left: 2rem;
        }
      }
    }
  }

  .right {
    text-align: right;
    width: 100%;
    display: none;

    img {
      position: relative;
      max-width: 100%;
    }

    @media (min-width: 768px) {
      display: block;
      width: 50%;

      img {
        right: -5%;
      }
    }

    @media (min-width: 1440px) {
      width: 40%;

      img {
        right: -3%;
      }
    }
  }
}
</style>
